export const TheSFTAddress = "0xf853bCD8B4e9020400d10F6edf241C4962D24d6c";
